import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { Component } from '@angular/core';

import { JsonConfiguration } from './app.json';
import { MonitoringService } from './core/services/monitoring/monitoring.service';

registerLocaleData(localeEs, 'es');
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  providers: [JsonConfiguration],
})
export class AppComponent {
  constructor(
    private jsonConfiguration: JsonConfiguration,
    private monitoringService: MonitoringService
  ) {
    this.jsonConfiguration.addSvgIcons();
    this.monitoringService.loadScript();
  }
}
